import { VENDORS, VendorConfig } from 'configuration/config';

/**
 * Derives vendor label from a SKU string by matching the prefix against VENDORS config.
 * Returns 'Other' if no match found.
 */
export function deriveVendorFromSku(sku: string): string {
    if (!sku) return 'Other';
    const upper = sku.toUpperCase();
    const match = VENDORS.find(v => upper.startsWith(`${v.skuPrefix.toUpperCase()}-`));
    return match ? match.label : 'Other';
}

/**
 * Returns vendors that handle external/reseller orders (SHI, CDW), plus Direct for bulk order
 * templates. Each vendor's `id` is resolved to its `bulkOrderVendorId` when set, so callers get
 * the value actually stored on bulk order templates without needing to know about the override.
 */
export function getBulkVendors(): VendorConfig[] {
    return VENDORS.filter(v => v.isBulkVendor).map(v => v.bulkOrderVendorId ? { ...v, id: v.bulkOrderVendorId } : v);
}
